/* eslint-disable @typescript-eslint/no-explicit-any */
import { combineReducers } from "@reduxjs/toolkit";
import priceTransparencyReducer from "./price transparency/price-transparency-slice";
import benefitBreakdownReducer from "./price transparency/benefit-breakdown-slice";
import appAlertDialogReducer from "./app-alert-dialog/app-alert-dialog-slice";
import providerSearchReducer from "./provider-search/provider-search-slice";
import chatbotReducer from "./chatbot/chatbot-slice";
import activeCoverageReducer from "./active-coverage-slice";
import requestIdReducer from "@/store/request-id-card/requestId-slice";
import csrChatReducer from "./csr-chat/csr-chat-slice";
import notificationReducer from "./notification/notification-slice";
import featureListReducer from "@/store/feature-list-slice";
import widgetListReducer from "@/store/widget-list-slice";
import { hcbbResultViewReducer } from "./hcbb-cost-estimator/hcbb-result-view-slice";
import { hcbbAdvancedFiltersReducer } from "./hcbb-cost-estimator/hcbb-advanced-filters-slice";

export const REDUX_STORE = {
  ACTION: { LOGOUT: "user/logout" },
};

const combinedReducers = combineReducers({
  planCoverageInfo: activeCoverageReducer,
  priceTransparency: priceTransparencyReducer,
  hcbbResultView: hcbbResultViewReducer,
  hcbbAdvancedFilters: hcbbAdvancedFiltersReducer,
  benefitBreakdown: benefitBreakdownReducer,
  appAlertDialog: appAlertDialogReducer,
  providerSearch: providerSearchReducer,
  chatbot: chatbotReducer,
  requestId: requestIdReducer,
  csrChat: csrChatReducer,
  notification: notificationReducer,
  featureList: featureListReducer,
  widgetList: widgetListReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === REDUX_STORE.ACTION.LOGOUT) {
    state = undefined;
  }

  return combinedReducers(state, action);
};

export default rootReducer;
